"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Wholesale integrations Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@deliverr.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarehouseOrderType = void 0;
/**
 *
 * @export
 * @enum {string}
 */
exports.WarehouseOrderType = {
    Removal: 'REMOVAL',
    Liquidation: 'LIQUIDATION',
    Consolidation: 'CONSOLIDATION',
    Transfer: 'TRANSFER',
    Disposal: 'DISPOSAL',
    Fulfillment: 'FULFILLMENT',
    Wholesale: 'WHOLESALE',
    Test: 'TEST',
    Forwarding: 'FORWARDING',
    B2BPrep: 'B2B_PREP',
    FwdPrep: 'FWD_PREP',
    EachPickOrder: 'EACH_PICK_ORDER',
    EcomPrep: 'ECOM_PREP'
};
//# sourceMappingURL=warehouse-order-type.js.map